import { Injectable } from '@angular/core';

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of, from } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom, tap, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { ContactHistoryActions } from '@actions/index'
import * as fromApp from '@reducers/index'
import { ContactHistoryModel, ContactHistoryCampaignModel, RequestModel, LocationModel } from '@models/index';
import { HttpApiService } from '@services/http-api.service';


@Injectable()
export class ContactHistoryEffects {

    searchContactHistoryByLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContactHistoryActions.searchContactHistoryByLocation),
            map(action => action.request),
            withLatestFrom(
                this.store.select(fromApp.getCurrentLocation),
                (request: RequestModel, location: LocationModel) => ({
                    ...request,
                    params: request.params + `&locationId=${location.id}`
                })
            ),
            switchMap(request =>
                this.httpApiService
                    .getRequest(request)
                    .pipe(
                        map(data => data as ContactHistoryModel),
                        map(data => ContactHistoryActions.searchContactHistorySuccess({ data })),
                        catchError(error => of(ContactHistoryActions.contactHistoryError({ error: error.message })))
                    )
            )
        )
    );

    searchContactHistoryByBusiness$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ContactHistoryActions.searchContactHistoryByBusiness),
            map(action => action.request),
            switchMap(request =>
                this.httpApiService
                    .getRequest(request)
                    .pipe(
                        map(data => data as ContactHistoryModel),
                        map(data => ContactHistoryActions.searchContactHistorySuccess({ data })),
                        catchError(error => of(ContactHistoryActions.contactHistoryError({ error: error.message })))
                    )
            )
        )
    );

    restartCampaignContactHistory = createEffect(() => 
        this.actions$.pipe(
            ofType(ContactHistoryActions.restartCampaignContactHistory),
            map(action => action.request),
            filter(value => value !== undefined),
            switchMap(request => 
                this.httpApiService
                    .postRequest(request)
                    .pipe(
                        map(data => data as ContactHistoryModel),
                        map(contactHistory => ContactHistoryActions.restartCampaignContactHistorySuccess({ contactHistory })),
                        catchError(error => of(ContactHistoryActions.contactHistoryError({ error: error.message })))
                    )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private httpApiService: HttpApiService,
        private store: Store<any>
    ) { }
}